import { Head } from "@inertiajs/react";
import { t } from "@travily/i18n";
import {
  foundingMemberCreatorPath,
  foundingMemberCreatorPausePath,
  foundingMemberCreatorStagePath,
} from "@travily/routes";
import type FoundingMemberCreatorFamilyConnect from "@travily/types/pages/FoundingMemberCreatorFamilyConnect";
import { useCreatorTopBarActions } from "@/lib/wizard/use-creator-top-bar-actions";
import { useWizardForm } from "@/lib/wizard/use-wizard-form";
import { FamilyConnectStepView } from "./show.view";

type FormData = {
  family_profile: {
    socials: string;
  };
};

const FIELD = "family_profile.socials";

const ConnectStep = ({ stage_index, stage_order, family_profile }: FoundingMemberCreatorFamilyConnect) => {
  const { form, validate, fieldError, currentStage, totalStages, onBack, onPrimary, primaryPending, onPause } =
    useWizardForm<FormData>({
      routes: {
        stageUrl: (stage) => foundingMemberCreatorStagePath("family", stage),
        entryUrl: foundingMemberCreatorPath(),
        pauseUrl: foundingMemberCreatorPausePath(),
      },
      stageName: "connect",
      stageIndex: stage_index,
      stageOrder: stage_order,
      initialData: { family_profile: { socials: family_profile.socials ?? "" } },
    });

  const error = fieldError(FIELD);

  const topBarActions = useCreatorTopBarActions({ onPause });

  return (
    <>
      <Head title={t("web.founding_members.creator.steps.family.connect.show.meta_title")}>
        <meta
          name="description"
          content={t("web.founding_members.creator.steps.family.connect.show.meta_description")}
        />
      </Head>
      <FamilyConnectStepView
        currentStage={currentStage}
        totalStages={totalStages}
        onBack={onBack}
        topBarActions={topBarActions}
        onPrimary={onPrimary}
        primaryPending={primaryPending}
        error={error}
        socials={form.data.family_profile.socials}
        onSocialsChange={(value) => {
          form.setData(FIELD, value);
          validate(FIELD);
        }}
      />
    </>
  );
};

export default ConnectStep;
